import { getAllowActionByCurrRole } from "@/utils/get-roles";
const INIT_FILTER_VALUE = {
  osm: null,
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  advance_filter: false,
  family_range: {
    start: null,
    end: null,
  },
  house_type: [],
  house_solidity: null,
  household_type: [],
  member_range: {
    start: null,
    end: null,
  },
  problems: [],
  volunteer: localStorage.getItem("volunteerData")
    ? JSON.parse(localStorage.getItem("volunteerData"))
    : null,
  cm_uid: null,
};

const state = () => {
  return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
  //   START: address
  setAddress({ commit }, address) {
    commit("setAddress", address);
  },
  setAmphur({ commit }, amphur) {
    commit("setAmphur", amphur);
  },
  setProvince({ commit }, province) {
    commit("setProvince", province);
  },
  setTumbol({ commit }, tumbol) {
    commit("setTumbol", tumbol);
  },
  setVillage({ commit }, village) {
    commit("setVillage", village);
  },
  //   END: address
  //   START: advance_filter
  setAdvanceFilter({ commit }, boo) {
    commit("setAdvanceFilter", boo);
  },
  toggleAdvanceFilter({ commit }) {
    commit("toggleAdvanceFilter");
  },
  //   END: advance_filter
  //   START: family_range
  setFamilyRange({ commit }, range) {
    commit("setFamilyRange", range);
  },
  setFamilyRangeStart({ commit }, start) {
    commit("setFamilyRangeStart", start);
  },
  setFamilyRangeEnd({ commit }, end) {
    commit("setFamilyRangeEnd", end);
  },
  // END: family_range
  //   START: house_type
  appendHouseType({ commit }, house_type) {
    commit("appendHouseType", house_type);
  },
  removeHouseType({ commit }, house_type) {
    commit("removeHouseType", house_type);
  },
  setHouseType({ commit }, house_types) {
    commit("setHouseType", house_types);
  },
  // END: house_type
  // START: household_type
  appendHouseholdType({ commit }, household_type) {
    commit("appendHouseholdType", household_type);
  },
  removeHouseholdType({ commit }, household_type) {
    commit("removeHouseholdType", household_type);
  },
  setHouseholdType({ commit }, household_types) {
    commit("setHouseholdType", household_types);
  },
  //   END: household_type
  //   START: house_solidity
  setHouseSolidity({ commit }, house_solidity) {
    commit("setHouseSolidity", house_solidity);
  },
  // END: house_solidity
  //   START: member_range
  setMemberRange({ commit }, member_range) {
    commit("setMemberRange", member_range);
  },
  setMemberRangeStart({ commit }, start) {
    commit("setMemberRangeStart", start);
  },
  setMemberRangeEnd({ commit }, end) {
    commit("setMemberRangeEnd", end);
  },
  // END: member_range
  // START: problems
  appendProblem({ commit }, problem) {
    commit("appendProblem", problem);
  },
  removeProblem({ commit }, problem) {
    commit("removeProblem", problem);
  },
  setProblem({ commit }, problems) {
    commit("setProblem", problems);
  },
  //   END: problems
  //   START: volunteer
  setVolunteer({ commit }, volunteer) {
    commit("setVolunteer", volunteer);
  },
  // END: volunteer
  // START: cm
  setCM({ commit }, cm_uid) {
    commit("setCM", cm_uid);
  },
  // END: cm
  setOSM({ commit }, osm) {
    commit("setOSM", osm);
  },
};

// mutations
const mutations = {
  // START: cm
  setCM(state, cm_uid) {
    state.cm_uid = cm_uid;
  },
  // END: cm
  clearStore(state) {
    state = { ...INIT_FILTER_VALUE };
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
  //   START: address
  setAddress(state, address) {
    state.address = address;
  },
  setProvince(state, province) {
    state.address.province = province;
  },
  setAmphur(state, amphur) {
    state.address.amphur = amphur;
  },
  setTumbol(state, tumbol) {
    state.address.tumbol = tumbol;
  },
  setVillage(state, village) {
    state.address.village = village;
  },
  //   END: address
  //   START: advance_filter
  setAdvanceFilter(state, boo) {
    state.advance_filter = boo;
  },
  toggleAdvanceFilter(state) {
    state.advance_filter = !state.advance_filter;
  },
  //   END: advance_filter
  //   START: family_range
  setFamilyRange(state, { start, end }) {
    state.family_range = { start, end };
  },
  setFamilyRangeStart(state, start) {
    state.family_range.start = start;
  },
  setFamilyRangeEnd(state, end) {
    state.family_range.end = end;
  },
  // END: family_range
  // START: house_type
  appendHouseType(state, house_type) {
    state.house_type.push(house_type);
  },
  removeHouseType(state, house_type) {
    state.house_type = state.house_type.filter((type) => type !== house_type);
  },
  setHouseType(state, house_types) {
    state.house_type = house_types;
  },
  // END: house_type
  // START: household_type
  appendHouseholdType(state, household_type) {
    state.household_type.push(household_type);
  },
  removeHouseholdType(state, household_type) {
    state.household_type = state.household_type.filter(
      (type) => type !== household_type
    );
  },
  setHouseholdType(state, household_types) {
    state.household_type = household_types;
  },
  //   END: household_type
  //   START: house_solidity
  setHouseSolidity(state, house_solidity) {
    state.house_solidity = house_solidity;
  },
  //   END: house_solidity
  //   START: member_range
  setMemberRange(state, { start, end }) {
    state.member_range = { start, end };
  },
  setMemberRangeStart(state, start) {
    state.member_range.start = start;
  },
  setMemberRangeEnd(state, end) {
    state.member_range.end = end;
  },
  // END: member_range
  // START: problems
  appendProblem(state, problem) {
    state.problems.push(problem);
  },
  removeProblem(state, problem) {
    state.problems = state.problems.filter((type) => type !== problem);
  },
  setProblem(state, problems) {
    state.problems = problems;
  },
  //   END: problems
  //   START: volunteer
  setVolunteer(state, volunteer) {
    state.volunteer = volunteer;
  },
  // END: volunteer
  setOSM(state, osm) {
    state.osm = osm;
  },
};

// {
//   address: {
//     amphur: null,
//     province: null,
//     tumbol: null,
//     village: null,
//   },
//   advance_filter: false,
//   family_range: {
//     start: null,
//     end: null,
//   },
//   house_type: [],
//   house_solidity: null,
//   household_type: [],
//   member_range: {
//     start: null,
//     end: null,
//   },
//   problems: [],
//   volunteer: null,
// }
// getters
const getters = {
  address: (state) => state.address,
  province: (state) => state.address.province,
  amphur: (state) => state.address.amphur,
  tumbol: (state) => state.address.tumbol,
  vaillage: (state) => state.address.village,
  advance_filter: (state) => state.advance_filter,
  family_range: (state) => state.family_range,
  house_type: (state) => state.house_type,
  house_solidity: (state) => state.house_solidity,
  household_type: (state) => state.household_type,
  member_range: (state) => state.member_range,
  problems: (state) => state.problems,
  volunteer: (state) => state.volunteer,
  getAllFilter: (state) => {
    if (state.advance_filter) return state;
    const commonFilter = {
      ...state,
      advance_filter: false,
      family_range: {
        start: null,
        end: null,
      },
      house_type: [],
      house_solidity: null,
      member_range: {
        start: null,
        end: null,
      },
      problems: [],
      volunteer: null,
    };
    if (localStorage.getItem("volunteerData")) {
      commonFilter.volunteer = JSON.parse(
        localStorage.getItem("volunteerData")
      );
    }
    return commonFilter;
  },
  getCommonFilter: (state) => {
    const commonFilter = {
      address: state.address,
      household_type: state.household_type,
    };
    return commonFilter;
  },
  getFilterSummaryArray: (state, getters, rootState, rootGetters) => {
    let prepareState = { ...state };
    if (!prepareState.advance_filter) {
      prepareState = {
        ...prepareState,
        family_range: {
          start: null,
          end: null,
        },
        house_solidity: null,
        house_type: [],
        member_range: {
          start: null,
          end: null,
        },
        problems: [],
        volunteer: null,
      };
    }

    let result = [];
    // address
    if (prepareState.address.province || getAllowActionByCurrRole("default-provinceCode-search"))
      result.push({
        title: "จังหวัด",
        text: prepareState.address.province ? prepareState.address.province.province_name : rootGetters["userAuth/getTokenParsed"]['provinceName']
        ,
      });
    if (prepareState.address.amphur)
      result.push({
        title: "อำเภอ/เขต",
        text: prepareState.address.amphur.amphur_name,
      });
    if (prepareState.address.tumbol)
      result.push({
        title: "ตำบล/แขวง",
        text: prepareState.address.tumbol.tumbol_name,
      });
    if (prepareState.address.village)
      result.push({
        title: "หมู่บ้าน",
        text: prepareState.address.village.village_name,
      });

    if (prepareState.household_type.length > 0)
      result.push({
        title: "ลักษณะครัวเรือน",
        text: prepareState.household_type.map((item) => item.desc).join(", "),
      });

    if (prepareState.problems.length > 0)
      result.push({
        title: "สภาพปัญหา",
        text: prepareState.problems.join(", "),
      });

    if (prepareState.house_solidity)
      result.push({
        title: "สภาพบ้าน",
        text: prepareState.house_solidity,
      });

    if (prepareState.house_type.length > 0)
      result.push({
        title: "ที่พักอาศัย",
        text: prepareState.house_type.map((item) => item.desc).join(", "),
      });

    if (
      typeof prepareState.family_range.start === "number" &&
      prepareState.family_range.end
    ) {
      result.push({
        title: "จำนวนครอบครัว",
        text: `${prepareState.family_range.start} - ${prepareState.family_range.end}`,
      });
    } else if (prepareState.family_range.start) {
      result.push({
        title: "จำนวนครอบครัว",
        text: `${prepareState.family_range.start} ขึ้นไป`,
      });
    } else if (prepareState.family_range.end) {
      result.push({
        title: "จำนวนครอบครัว",
        text: `น้อยกว่า ${prepareState.family_range.end}`,
      });
    }

    if (
      typeof prepareState.member_range.start === "number" &&
      prepareState.member_range.end
    ) {
      result.push({
        title: "จำนวนสมาชิก",
        text: `${prepareState.member_range.start} - ${prepareState.member_range.end}`,
      });
    } else if (prepareState.member_range.start) {
      result.push({
        title: "จำนวนสมาชิก",
        text: `${prepareState.member_range.start} ขึ้นไป`,
      });
    } else if (prepareState.member_range.end) {
      result.push({
        title: "จำนวนสมาชิก",
        text: `น้อยกว่า ${prepareState.member_range.end}`,
      });
    }
    if (prepareState.volunteer) {
      result.push({
        title: "อพม.",
        text: `${prepareState.volunteer.title}${prepareState.volunteer.name} ${prepareState.volunteer.surname}`,
      });
    }
    return result;
  },
  getFilterForApi: (state, getters, rootState, rootGetters) => {
    const result = {};
    //action include default-provinceCode-search send provCode for default
    if (
      getAllowActionByCurrRole("default-provinceCode-search") ||
      state.address.province
    ) {
      result.prov = state.address.province
        ? state.address.province._id.province_ID.toString()
        : rootGetters["userAuth/getTokenParsed"]["provinceCode"].toString();
    }
    if (state.address.amphur)
      result.amp = state.address.amphur._id.amphur_ID.toString();
    if (state.address.tumbol)
      result.tam = state.address.tumbol._id.tumbol_ID.toString();
    if (state.address.village)
      result.vil = state.address.village._id.village_ID.toString();
    if (state.household_type.length > 0) {
      result.hh_type = state.household_type.map((item) => item.code);
    }
    if (state.advance_filter) {
      if (state.house_type.length > 0)
        result.house_type = state.house_type.map((item) => item.code);
      if (state.house_solidity)
        result.house_solid = state.house_solidity === "มั่นคงแข็งแรง" ? "1" : "0";
      if (state.problems.length > 0) {
        for (const index in state.problems) {
          const value = state.problems[index];
          if (value === "ปัญหาด้านสุขภาพ") result.prob_health = "1";
          if (value === "ปัญหาด้านครัวเรือน") result.prob_family = "1";
          if (value === "ปัญหาด้านการศึกษา") result.prob_education = "1";
          if (value === "ปัญหาด้านการเงิน") result.prob_occupation = "1";
          if (value === "ปัญหาด้านการเข้าถึงสิทธิ")
            result.prob_accessibility = "1";
        }
      }
      if (state.family_range.start || state.family_range.end) {
        result.family_cnt_range = `[${
          state.family_range.start ? state.family_range.start : ""
        },${state.family_range.end ? state.family_range.end : ""}]`;
      }
      if (state.member_range.start || state.member_range.end) {
        result.member_cnt_range = `[${
          state.member_range.start ? state.member_range.start : ""
        },${state.member_range.end ? state.member_range.end : ""}]`;
      }
      if (state.volunteer) result.volunteer_id = state.volunteer.national_id;
    }
    //if vt role send volunteer for default
    if (rootGetters["userAuth/getUserRoleCode"] === "vt") {
      if (state.volunteer) result.volunteer_id = state.volunteer.national_id;
    }
    //if action include default-cm_uid-search send cm_uid for default
    if (getAllowActionByCurrRole("default-cm_uid-search")) {
      result.cm_uid = state.cm_uid
        ? state.cm_uid
        : rootGetters["userAuth/getUsername"];
    }
    return result;
  },

  //   {
  //     "prov":"14", c
  //     // "amp": "222", c
  //     // "tam": "1234", c
  //     //"hh_type":"hh_type.code" Array c
  //     //"house_type":"house_type.code" Array c
  //     //"house_solid":1 c
  //     //"volunteer_id":"volunteer_id??"
  //     //prob_housing":1,
  //     //"prob_health":1 c
  //     //"prob_education":1 c
  //     //"prob_occupation":1 c
  //     //"prob_family":1 c
  //     //"prob_violence":1 ยังไม่ต้อง
  //     //"prob_human_trafficking":1 ยังไม่ต้อง
  //     //"prob_accessibility":1 c
  //     //"prob_others":1 ยังไม่ต้อง
  //     //"family_cnt_range":"[1,1]",
  //     "member_cnt_range":"[2,5]",
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
